export const CHART_COLORS = {
  primary: '#4A90D9',
  secondary: '#50C878',
  tertiary: '#FF6B6B',
  quaternary: '#FFD93D',
  purple: '#9B59B6',
  orange: '#F39C12',
  teal: '#1ABC9C',
  pink: '#E91E63',

  // For sequential data
  palette: ['#4A90D9', '#50C878', '#FF6B6B', '#FFD93D', '#9B59B6', '#F39C12', '#1ABC9C', '#E91E63'],

  // For positive/negative
  positive: '#50C878',
  negative: '#FF6B6B',
  neutral: '#FFD93D',

  // For background
  lightBg: '#F7FAFC',
  cardBg: '#FFFFFF',
};
